// Single datetime display format for the whole viewer: local time as
// "yyyy-mm-dd hh:mm:ss" (24-hour), matching what the sessions time-range
// filter accepts. toLocaleString() is deliberately avoided — its shape
// varies with the browser locale.
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const p = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ` +
    `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
